module.exports = __webpack_public_path__ + "assets/images/quote-left-black.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/quote-left-black.png
 ** module id = 26
 ** module chunks = 0
 **/